import {findAsync} from '../lib/api/rest/strapi';
import {paths} from '../lib/api/rest/paths';
import remark from 'remark';
import html from 'remark-html';
import React, {useEffect, useState} from 'react';
import {TextLayoutPage} from '../components/layout/textLayoutPage';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import LoginForm from '../components/auth/loginForm';
import SimpleAccordion from '../components/simpleComponents/simpleAccordion';
import qs from 'qs';
import {generateFaqJsonLd} from '../lib/utils/googleUtils';
import {useTranslation} from 'next-i18next';

export default function FAQ({data}) {
  const {t: translateSiteMeta} = useTranslation('site-meta');
  const {t: translateMenu} = useTranslation('menu');

  const {list} = data;
  const faqJsonLd = generateFaqJsonLd(list);

  return <TextLayoutPage title={translateMenu('FAQ')} faqJsonLd={faqJsonLd} description={translateSiteMeta('FAQ_META_DESCRIPTION')}>

    <SimpleAccordion
        className={``}
        cardClassname={'mb-5 bg-gray-50 p-5 rounded'}
        titleContainerClassName={'text-lg text-gray-900'}
        contentContainerClassName={'text-sm mt-2 text-gray-800'}
        useMarkdownContent={true}
        elements={list}/>

  </TextLayoutPage>;

};

export async function getStaticProps({params, locale, defaultLocale}) {
  const intl = locale !== defaultLocale;

  let _query = {};

  if (intl) {
    _query = {
      ..._query,
      _locale: locale,
    };
  }
  const qaData = await findAsync(paths.FAQ, false, qs.stringify(_query), false);

  const qaList = parseQaList(qaData);

  function parseQaList(data) {

    const qaList = [];

    data.map(elem => {
      const {question, answer} = elem;

      remark().
          use(html).
          process(answer).then((file) => {

        const {contents} = file;

        const item = {
          title: question,
          content: contents,
        };

        return qaList.push(item);

      });

    });

    return qaList;

  }

  const data = {
    list: qaList,
  };

  return {
    props: {
      data: data || {},
      ...(await serverSideTranslations(locale,
          ['common', 'pages', 'products', 'site-meta', 'menu'])),
    },
  };
}
